<template>
  <div>
    <el-container>
      <el-main>
        <h2>Change PEA Status</h2><br>
        <el-row :gutter="20">
          <el-col :span="6">
            <strong>PEA Id</strong>
            <el-input v-model="peaId" label="PEA id"></el-input>
          </el-col>
          <el-col :span="6">
            <div v-if="pea">
              <strong>PEA Status</strong>
              <status-dropdown :inputModel="pea.peaStatusId" @input="selectStatus" @changed="update = true" :disabled="!canChange" :title="selectTitle" :statusAllowed="statusAllowed" :key="pea.peaStatusId" />
            </div>
          </el-col>
        </el-row>
        <br>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-button type="primary" @click="findPEA">Find PEA</el-button>
          </el-col>
          <el-col :span="6">
            <el-button v-if="update && canChange" type="success" @click="updateStatus">Update Status</el-button>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  data () {
    return {
      peaId: null,
      pea: null,
      update: false
    }
  },
  computed: {
    canChange () {
      var allowed = ['Approved', 'Canceled', 'Complete']
      if (allowed.includes(this.pea.peaStatus)) {
        return true
      }
      return false
    },
    statusAllowed () {
      if (this.pea.peaStatus === 'Approved') {
        return ['Complete', 'Canceled']
      }
      if (this.pea.peaStatus === 'Canceled') {
        return ['Approved']
      }
      if (this.pea.peaStatus === 'Complete') {
        return ['Approved', 'Canceled']
      }
    },
    selectTitle () {
      return !this.canChange ? 'This status cannot be changed' : ''
    }
  },
  methods: {
    findPEA () {
      this.$axios.get('/adminGetPEASummary/' + this.peaId).then(pea => {
        this.pea = pea.data
      }).catch(response => {
        helperMethods.showNotification(this, 'PEA Not Found', 'A PEA with the id ' + this.peaId + ' was not found', 'error', 10000)
      })
    },
    selectStatus (input) {
      this.pea.peaStatusId = input
    },
    updateStatus () {
      this.$axios.post('/adminUpdatePEASummary/' + this.peaId, this.pea).then(response => {
        helperMethods.showNotification(this, 'PEA Update', 'Status updated for PEA ' + this.peaId, 'success', 10000)
      }).catch(response => {
        helperMethods.showNotification(this, 'PEA Update', 'Status update failed for PEA ' + this.peaId, 'error', 10000)
      })
    }
  }
}
</script>

<style>
</style>
